<template>
    <div class="app">
        <Navigation />

        <main>

            <div class="app__title">
                <h1>Discover</h1>
            </div>
            
            <div class="header__search">
                <input class="input--dark" type="search" placeholder="Search gear or song" v-model="query" />
            </div>

            <div v-if="!query" class="intro">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="intro__item">
                                <span>🎸</span>
                                <h2>1. Find or add gear</h2>
                                <p>Search for pedals, amps, guitars, ... and add them to your collection.</p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="intro__item">
                                <span>🎹</span>
                                <h2>2. Add and browse songs</h2>
                                <p>Create a song and link gear to that song.</p>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="intro__item">
                                <span>🎛</span>
                                <h2>3. Save gear settings</h2>
                                <p>Save your gear's settings (knobs, sliders, switches) per song and share it!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section v-if="searchResults.gear.length > 0">
                <h2>Gear</h2>

                <div class="gear__overview">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-12 m-b-1" v-for="g in searchResults.gear" :key="g.id">
                                <ListItemGear :gearId="g.id"></ListItemGear>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="searchResults.songs.length > 0">
                <h2>Songs</h2>

                <div  v-for="song in searchResults.songs" :key="song.id" class="song__item">
                    <router-link :to="'/songs/'+song.id">
                        {{ song.artist }} - {{ song.title }}
                    </router-link>

                    <div class="song__item__gear">
                        <span class="song__item__gear__item" v-for="gear in song.gear" :key="gear.gearId">
                            <GearImage :gearId="gear.gearId"/>
                        </span>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import Navigation from "@/components/Nav";
import { mapState } from 'vuex'
import ListItemGear from "./ListItemGear.vue";
import GearImage from './GearImage.vue';

export default {
    data() {
        return {
            query: '',
        };
    },
    computed: {
        ...mapState(['gear', 'user', 'songs']),
        searchResults() {
            var gear = [],
                songs = []
            if(this.query) {
                gear = this.gear.filter(item => {
                    var term = (item.brand+" "+item.title).toLowerCase()
                    return term.search(this.query.toLowerCase()) > -1
                })
                
                songs = this.songs.filter(item => {
                    var term = (item.artist+" "+item.title).toLowerCase()
                    return term.search(this.query.toLowerCase()) > -1
                })  
            }
            
            return { songs: songs, gear: gear }
        }
    },
    components: { Navigation, ListItemGear, GearImage },
    methods: {
        search: function() {

        }
    },
    created() {
    },
    destroyed() {
    },
}
</script>